import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from '../shared/shared.module';
import { SignInRoutingModule } from './sign-in-routing.module';
import { SignInComponent } from './sign-in.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { ForgotFormComponent } from './forgot-form/forgot-form.component';
import { ForgotSuccessComponent } from './forgot-success/forgot-success.component';
import { UpdateFormComponent } from './update-form/update-form.component';
import { ActivateFormComponent } from './activate-form/activate-form.component';
import { SendCodeFormComponent } from './send-code-form/send-code-form.component';
import { VerifyCodeFormComponent } from './verify-code-form/verify-code-form.component';
import { LinkUsedErrorComponent } from './link-used-error/link-used-error.component';
import { LinkExpiredErrorComponent } from './link-expired-error/link-expired-error.component';

@NgModule({
  declarations: [
    SignInComponent,
    LoginFormComponent,
    ForgotFormComponent,
    ForgotSuccessComponent,
    UpdateFormComponent,
    ActivateFormComponent,
    SendCodeFormComponent,
    VerifyCodeFormComponent,
    LinkUsedErrorComponent,
    LinkExpiredErrorComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MessagesModule,
    ToastModule,
    MessageModule,
    SignInRoutingModule,
    ButtonModule,
    ReactiveFormsModule,
  ],
})
export class SignInModule {}
